"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ApplicationConfiguration_1 = require("../ApplicationConfiguration");

var ApplicationConfigurationConverter_1 = require("./ApplicationConfigurationConverter");
/**
 * Implementation of {@link ApplicationConfigurationConverter}.
 *
 * @author RV
 */


var ApplicationConfigurationConverterImpl =
/*#__PURE__*/
function (_ApplicationConfigura) {
  _inherits(ApplicationConfigurationConverterImpl, _ApplicationConfigura);

  function ApplicationConfigurationConverterImpl() {
    _classCallCheck(this, ApplicationConfigurationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApplicationConfigurationConverterImpl).apply(this, arguments));
  }

  _createClass(ApplicationConfigurationConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ApplicationConfiguration_1.ApplicationConfiguration(ApplicationConfiguration_1.ApplicationConfiguration.schema.categoryLevel.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.currencyCode.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.version.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.pricingVersion.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.promoVersion.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.timezone.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.locale.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.localeSpec.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.mode.valueOfField(source), ApplicationConfiguration_1.ApplicationConfiguration.schema.recalculation.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        categoryLevel: source.categoryLevel,
        currencyCode: source.currencyCode,
        version: source.version,
        pricingVersion: source.pricingVersion,
        promoVersion: source.promoVersion,
        timezone: source.timezone,
        locale: source.locale,
        localeSpec: source.localeSpec,
        mode: source.mode,
        recalculation: {
          appRecalcFrom: source.recalculation.appRecalcFrom.serialize(),
          appRecalcTo: source.recalculation.appRecalcTo.serialize()
        }
      });
      return result;
    }
  }]);

  return ApplicationConfigurationConverterImpl;
}(ApplicationConfigurationConverter_1.ApplicationConfigurationConverter);

exports.ApplicationConfigurationConverterImpl = ApplicationConfigurationConverterImpl;